import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'ugc-swipe',
  shadow: false,
})
export class UgcSwipe {
  @Prop() isRTL: boolean = false;
  @Prop() handleSwipeLeft: () => any;
  @Prop() handleSwipeRight: () => any;
  @State() x: number = 0;
  @State() delta: number = 0;
  ulElement!: HTMLDivElement;

  flag = false;

  handleTouchStart = e => {
    const {
      touches: {
        0: { clientX },
      },
    } = e;
    this.x = clientX;
  };

  handleTouchMove = e => {
    const {
      touches: {
        0: { clientX },
      },
    } = e;
    this.delta = this.x - clientX;
    this.ulElement.style.transition = 'none';
    this.ulElement.style.opacity = '0.5';
    this.flag = true;
    e.preventDefault();
  };

  handleTouchEnd = () => {
    if (this.flag) {
      if (Math.abs(this.delta) > 50) {
        if (this.delta > 0) {
          this.isRTL ? this.handleSwipeLeft() : this.handleSwipeRight();
        } else {
          this.isRTL ? this.handleSwipeRight() : this.handleSwipeLeft();
        }
        this.ulElement.style.transition = 'all .3s';
        this.ulElement.style.opacity = '1';
      } else {
        this.ulElement.style.transition = 'all .1s';
        this.ulElement.style.opacity = '1';
      }
    }
    this.delta = 0;
  };
  render() {
    return (
      <div
        onTouchStart={this.handleTouchStart}
        onTouchEnd={this.handleTouchEnd}
        onTouchMove={this.handleTouchMove}
        ref={el => (this.ulElement = el)}
      >
        <slot />
      </div>
    );
  }
}
